// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import { mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import { spacing } from 'frontend_core/dist/styles/variables'
import MainContents from 'components/templates/MainContents'
import { type ReservationType } from 'types/reservation'
import Button from 'components/atoms/Button'
import HeadlineReservation from 'components/molecules/HeadlineReservation'

export type PropTypes = {
  isSuccess: boolean,
  onClickBack: Function,
}

export default props => (
  <MainContents>
    {props.isSuccess ? (
      <Fragment>
        <HeadlineReservation
          title={i18n.t('page.dashboard.reservation.examinationPassingTitle')}
        >
          {i18n.t('page.dashboard.reservation.examinationPassingText')}
        </HeadlineReservation>
        <NoticeText>
          {i18n.t('page.dashboard.reservation.examinationPassingNoticeText')}
        </NoticeText>
        <ButtonWrap>
          <Button
            buttonType="huge"
            colorType="blue"
            tag="anchor"
            fontSizePc="{16}"
            buttonWidthPc="384"
            fontSizeSp="{14}"
            fullWidthSp
            onClick={props.onClickBack}
          >
            {i18n.t('page.dashboard.reservation.backToHowtoPay')}
          </Button>
        </ButtonWrap>
      </Fragment>
    ) : (
      <Fragment>
        <HeadlineReservation
          title={i18n.t('page.dashboard.reservation.examinationUnPassingTitle')}
        >
          {i18n.t('page.dashboard.reservation.examinationUnPassingText1')}
          <br />
          {i18n.t('page.dashboard.reservation.examinationUnPassingText2')}
        </HeadlineReservation>
        <ButtonWrap>
          <Button
            buttonType="huge"
            colorType="blue"
            tag="anchor"
            fontSizePc="{16}"
            buttonWidthPc="384"
            fontSizeSp="{14}"
            fullWidthSp
            onClick={props.onClickBack}
          >
            {i18n.t('page.dashboard.reservation.chnageHowtoPay')}
          </Button>
        </ButtonWrap>
      </Fragment>
    )}
  </MainContents>
)

const NoticeText = styled.p`
  color: ${Colors.red};
  margin-top: ${spacing.small_3}px;
  ${mediaMin.phone`	
    margin-top: ${spacing.medium}px;
  `};
`
const ButtonWrap = styled.div`
  margin-top: ${spacing.medium_3}px;
  ${mediaMin.phone`	
    margin-top: ${spacing.large}px;
  `};
`



// WEBPACK FOOTER //
// ./src/components/pages/ReservationPayExaminationFinishPage/index.jsx